import type { ProviderBooking } from "../../lib/api";
import { useAppPreferences } from "../../lib/preferences";

type AccountLink = Pick<ProviderBooking, "customer_user_id" | "linked_account_name">;

export function BookingAccountIdentity({ booking }: { booking?: AccountLink | null }) {
  const { t } = useAppPreferences();
  // Null is a new staff booking; undefined is an older API without link data.
  const accountId = booking === null ? null : booking?.customer_user_id;
  return (
    <div className="ops-record ops-record-dense grid gap-1">
      <p className="ops-label">{t("Linked customer account")}</p>
      <p className="ops-copy text-sm break-words">
        {accountId === undefined
          ? t("Account link information is unavailable.")
          : accountId
            ? (booking?.linked_account_name || t("Registered customer"))
            : t("No linked account. Contact details do not grant app access.")}
      </p>
      {accountId ? <>
        <p className="ops-copy text-xs break-all" dir="ltr">{accountId}</p>
        <p className="ops-copy text-xs">{t("This account link cannot be edited by staff.")}</p>
      </> : null}
    </div>
  );
}
